enum fileType{
    GET_ALL_FILE_START='GET_ALL_FILE_START',
    GET_ALL_FILE_SUCCESS = 'GET_ALL_FILE_SUCCESS',
    GET_ALL_FILE_ERROR = 'GET_ALL_FILE_ERROR',
    FILE_PREPARATION_START='FILE_PREPARATION_START',
    FILE_PREPARATION_SUCCESS = 'FILE_PREPARATION_SUCCESS',
    FILE_PREPARATION_ERROR = 'FILE_PREPARATION_ERROR',
    RESET_FILE_PREPARATION_STATE = 'RESET_FILE_PREPARATION_STATE',
    DELETE_FILE_START='DELETE_FILE_START',
    DELETE_FILE_SUCCESS='DELETE_FILE_SUCCESS',
    DELETE_FILE_ERROR = 'DELETE_FILE_ERROR',
    RESET_DELETE_FILE_STATE = 'RESET_DELETE_FILE_STATE',
    DELETE_SELECTED_FILE_START='DELETE_SELECTED_FILE_START',
    DELETE_SELECTED_FILE_SUCCESS ='DELETE_SELECTED_FILE_SUCCESS',
    DELETE_SELECTED_FILE_ERROR ='DELETE_SELECTED_FILE_ERROR',
    RESET_DELETE_SELECTED_FILE_STATE='DELETE_SELECTED_FILE_STATE',
}

export default fileType;